export function getUserPlatform(): string {
  const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

  if (/android/i.test(ua)) {
    return 'Android';
  }
  if (/iPad|iPhone|iPod/.test(ua)) {
    return 'iOS';
  }
  // iPadOS 13+ in desktop mode
  if (/Macintosh/.test(ua) && 'ontouchend' in document) {
    return 'iOS';
  }
  if (/win/i.test(ua)) {
    return 'PC';
  }
  if (/macintosh|mac os x/i.test(ua)) {
    return 'PC';
  }
  if (/linux/i.test(ua) && !/android/i.test(ua)) {
    return 'PC';
  }
  return 'PC';
}
